export const PARCELS_LIST_VIEW = "/parcels"
export const PARCEL_VIEW = `${PARCELS_LIST_VIEW}/:parcelId`
export const NEW_PARCEL_VIEW = PARCELS_LIST_VIEW + "/new"
export const EDIT_PARCEL_VIEW = PARCEL_VIEW + "/edit"
export const PARCEL_EVENTS_VIEW = `${PARCELS_LIST_VIEW}/events`
export const NEW_PARCEL_EVENT_VIEW = `${PARCEL_EVENTS_VIEW}/new`
export const PARCEL_EVENT_VIEW = `${PARCEL_EVENTS_VIEW}/:parcelEventId`
